import { Button, Modal } from "react-bootstrap";
import { Case, ReferralImport } from "../../../../models";
import { useAxios } from "../../../../hooks";
import { useReferralDashboard } from "../../../../contexts";
import { Endpoints } from "../../../../api";

interface ReferralImportModalProps {
    onHide: () => void;
    onError: (error: unknown) => void;
    show: boolean;
    referralImport: ReferralImport;
}

export function ReferralImportModal({ onHide, onError, show, referralImport }: ReferralImportModalProps) {
    const { post, del } = useAxios();
    const { getDashboardData } = useReferralDashboard();

    const handleImport = async () => {
        try {
            await post<ReferralImport, Case>({ url: `${Endpoints.ReferralImports}/create`, data: referralImport });
        } catch (error) {
            onError(error);
        } finally {
            await getDashboardData();
            onHide();
        }
    };

    const handleIgnore = async () => {
        try {
            await del({ url: `${Endpoints.ReferralImports}/${referralImport.id}` });
        } catch (error) {
            onError(error);
        } finally {
            await getDashboardData();
            onHide();
        }
    };

    return (
        <Modal onHide={onHide} show={show} centered>
            <Modal.Header closeButton>Import Referral From iTransplant</Modal.Header>
            <Modal.Body>Do you want to import or ignore this referral?</Modal.Body>
            <Modal.Footer className="d-flex">
                <Button variant="outline-secondary" onClick={onHide}>
                    Cancel
                </Button>
                <Button variant="danger" onClick={handleIgnore}>
                    Ignore
                </Button>
                <Button variant="primary" onClick={handleImport}>
                    Import
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
